import { FC } from "react";
import { useI18n } from "../../../hooks/useTranslations";
import { useDueDateTypesApi } from "../../../http/dueDateTypes/api";
import HistoryDialog from "../../ui/HistoryDialog";
import VersionDialog from "../../ui/VersionDialog";

interface DueDateTypeHistoryDialogProps {
  itemToShowVersionsId: string;
  itemVersionToShowVersions: number;
  onClose: () => void;
}

const DueDateTypeHistoryDialog: FC<DueDateTypeHistoryDialogProps> = ({
  itemToShowVersionsId,
  itemVersionToShowVersions,
  onClose,
}) => {
  const i18n = useI18n();
  const dueDateTypesApi = useDueDateTypesApi();

  return (
    <HistoryDialog
      title={i18n.t.dueDateTypes.versions}
      lastVersion={itemVersionToShowVersions}
      entityId={itemToShowVersionsId}
      getEntityVersionHook={dueDateTypesApi.getAdminDueDateTypeVersion}
      getHistory={dueDateTypesApi.getAdminDueDateTypeHistory}
      onClose={onClose}
      renderForm={(headers, dataVersion) => (
        <>
          <VersionDialog.Table headers={headers}>
            <tr>
              <VersionDialog.Field
                label={i18n.t.common.name}
                value={dataVersion.current?.name}
                edited={dataVersion.next.name}
              />
            </tr>
          </VersionDialog.Table>
        </>
      )}
    />
  );
};

export default DueDateTypeHistoryDialog;
